export function numericOpeningPosition(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmed = value.trim();
  if (trimmed === '') {
    return undefined;
  }

  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed)) {
    return undefined;
  }

  return parsed;
}

export function withOpeningPosition<T extends { positionOnWall?: unknown }>(
  item: T,
  positionOnWall?: unknown
): T {
  const next = { ...item };
  const numeric = numericOpeningPosition(positionOnWall);

  if (numeric === undefined) {
    delete next.positionOnWall;
    return next;
  }

  return {
    ...next,
    positionOnWall: numeric
  };
}
